// extracted by mini-css-extract-plugin
export default {"history-messages-error":"styles_history-messages-error__qALud"};